export const environment = {
  production: false,
  apiUrl: 'https://bisciop-api-dev.wittyfield-5780e1d7.westeurope.azurecontainerapps.io/api',
  googleClientId: '1073317574701-v9iqkb8cg5o5mo7oqdnkcvvpsa6ejknl.apps.googleusercontent.com'
};
